export enum PropertyDetailsModalsEnum {
  DELETE_PROPERTY_MODAL = 'DELETE_PROPERTY_MODAL',
}
